export default __webpack_public_path__ + "static/hero-recipe-bg-desktop-b931099113d7020714ccef41e2839219.jpg";